import carIcon from "../assets/iconos/car.png";
import { useTranslation } from "react-i18next";

export const useModulosAdministracionUsuario = () => {
  const { t } = useTranslation();
  const MODULOS_ADMINISTRACION_USUARIO = [
    {
      id: 1,
      titulo: t("menu_usuarios_web"),
      descripcion: t("menu_usuarios_web"),
      icono: carIcon,
      color: "rgba(0, 128, 0, 0.5)",
      href: "usuario/listar-usuarios-web",
    },
    {
      id: 2,
      titulo: t("menu_usuarios_movil"),
      descripcion: t("menu_usuarios_movil"),
      icono: carIcon,
      color: "rgba(0, 128, 0, 0.5)",
      href: "usuario/listar-usuarios-movil",
    },
  ];
  return MODULOS_ADMINISTRACION_USUARIO;
};